/** @jsx jsx */
import { jsx, SerializedStyles } from '@emotion/core';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';
import { useTheme } from 'emotion-theming';

import { Theme } from 'features/Theme';

import styles from './styles';
import React from 'react';

interface PropTypes {
  /** Logo width in MUI's spacing unit. */
  width?: number;
  className?: string;
}

/**
 * Logo at the top of the page.
 */
const Logo: React.FC<PropTypes> = ({ className, width = 15 }) => {
  const tenant = useSelector(selectTenant);
  const theme = useTheme<Theme>();

  const css = (theme: Theme): SerializedStyles[] => [
    styles.logoContainer(theme, width),
  ];

  if (theme.embedded) {
    return null;
  }

  return (
    <React.Fragment>
      <div css={css} className={className}>
        <img src={tenant.logoUrl} alt={tenant.name} />
      </div>
    </React.Fragment>
  );
};

export default Logo;
